<template>
  <span class="tw-font-medium tw-text-sf-gray tw-text-base">{{
    pageTitle
  }}</span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['isPersisted']),
    pageTitle() {
      if (this.isPersisted) {
        return I18n.t('js.report_graph.edit.title.edit')
      } else {
        return I18n.t('js.report_graph.edit.title.new')
      }
    },
  },
}
</script>
